// ═══════════ DESIGN TOKENS ═══════════
export const C = {
  bg:    "#0f1419",
  bg2:   "#131820",
  bg3:   "#1a212c",
  line:  "#232d3d",
  line2: "#2a3647",
  t1:    "#e8e5df",
  t2:    "#8f8c87",
  t3:    "#7a7773",
  t4:    "#252320",
  up:    "#c03828",
  down:  "#2e6fa8",
  neut:  "#5c5a56",
  accent:"#b8720e",
  gun:   "#c03828",
  wshed: "#8b4f9e",
  notable:"#2e7d52",
  common: "#3a3835",
  socmint: "#E8593C",
  adversary: "#3B8BD4",
  serif: "'Libre Baskerville', Georgia, serif",
  serifKo: "'Noto Serif KR', '본명조', Georgia, serif",
  sans:  "system-ui, -apple-system, sans-serif",
  mono:  "'JetBrains Mono', 'Fira Mono', monospace",
};

export const CLS_META = {
  gun:     { label:"Smoking Gun",  color: C.gun,    border:"#c03828" },
  watershed:{ label:"Watershed",  color: C.wshed,  border:"#8b4f9e" },
  notable: { label:"Notable",     color: C.notable, border:"#2e7d52" },
  common:  { label:"Common Ground",color: C.t3,    border:"#2d2b28" },
};

export const WORKER_URL  = "https://desert-eye-v5-production.tompark100.workers.dev";
export const GEMINI_KEYS = [];
export const FLASH_MODEL = "gemini-2.5-flash";
export const PROXY_URL    = process.env.REACT_APP_PROXY_URL || "";
export const YOUTUBE_KEY  = process.env.REACT_APP_YOUTUBE_KEY || "";

export const TIER_UP = { common: "notable", notable: "watershed", watershed: "gun" };
export const TIER_DOWN = { gun: "watershed", watershed: "notable", notable: "common" };

export const TIER_ORDER = [
  { key:"gun",       label:"Smoking Gun" },
  { key:"watershed", label:"Watershed / Game Changer" },
  { key:"notable",   label:"Notable Update" },
  { key:"common",    label:"Common Ground" },
];

export const CLS_RANK = { gun: 0, watershed: 1, notable: 2, common: 3 };
